import { lazy } from 'react';

export const SetPasswordPage = lazy(() => import('./SetPasswordPage'));
